import React from 'react'

import Select from './controls/Select'

const CustomDropDown = ({
  id,
  name,
  value,
  onChange,
  onBlur,
  items,
  className,
  placeholderText,
  noOptionsMessage,
  allowFreeType,
  isDisabled = false,
  isClearable = false,
}) => {
  const options = items.map(x => ({ value: x.id, label: x.name }))
  let selectedValue = ''

  if (value != null) {
    const isGuid =
      typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
    selectedValue = options.find(x => x.value.toString().toLowerCase() === value.toString().toLowerCase()) || {
      value: -1,
      label: isGuid ? '' : value,
    }
  }

  return (
    <Select
      id={id}
      name={name}
      value={selectedValue}
      className={className}
      placeholder={placeholderText}
      options={options}
      onChange={onChange}
      onBlur={onBlur}
      isDisabled={isDisabled}
      isClearable={isClearable}
      autoComplete="off"
      noOptionsMessage={() => noOptionsMessage}
      allowFreeType={allowFreeType}
    />
  )
}

export default CustomDropDown
